import React from "react"
import { FaCode, FaSketch, FaAndroid } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Web Development",
    text: `I'm best at the MERN stack, but also have experience with SERN and PERN stack. Need a static site? No problem, I can build with Gatsby!`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "UI/UX",
    text: `I pride myself in simple, clean designs that provide a user with a great interface and experience`,
  },
  {
    id: 3,
    icon: <FaAndroid className="service-icon" />,
    title: "Mobile Applications",
    text: `I can also build mobile applications for IOS and Android with React Native!`,
  },
]
